import React from 'react';
import utils from '../utils';

type Props = {
  resource: string,
}

const SlideShow: React.FunctionComponent<Props> = ({ resource }) => (
  <iframe
    style={{
      border: "1px solid #CCC",
      borderWidth: 1,
      marginBottom: 5,
      maxWidth: "100%"
    }}
    src={utils.slideshowPath(resource)}
    frameBorder="0"
    width="500"
    height="310"
    marginWidth={0}
    marginHeight={0}
    scrolling="no"
    allowFullScreen={true}
    // @ts-ignore
    mozallowfullscreen="true"
    webkitallowfullscreen="true"
    title="SlideShare"
  ></iframe>
);

export default SlideShow;
